



































import { Component, Vue, Inject, Watch } from 'vue-property-decorator';

import ContoList from './ContoList.vue';
import EditConto from './conto/EditConto.vue';
import { Conto, ContoType } from '@/data/models/conto.model';
import store, { State } from '@/store';
import { BModalComponent } from 'buefy/types/components';
import { ContoService } from '@/data/services/conto.service';
import { CrudService } from '@/data/services/crud.service';

@Component({
	components: {
		ContoList,
		EditConto
	},
})
export default class Conti extends Vue {
	@Inject('ContoService') contoService!: ContoService;
	@Inject('CrudService') crudService!: CrudService<Conto>;

	state!: State;

	tab: string = ContoType.MASTRO;
	typeItems: string[] = Object.keys(ContoType).map(
		// @ts-ignore
		(k: string) => ContoType[k]
	);

	constructor() {
		super();
		this.state = store;
	}

	@Watch('tab', { immediate: true })
	onTabChange() {
		this.$nextTick(() => this.load());
	}

	load() {
		const ref = (this.$refs[`list${this.tab}`] as any[])[0];
		(ref as ContoList).loadConti();
	}

	saveConto(value: Conto, modal: BModalComponent) {
		this.contoService
			.create(this.tab, value)
			.then(() => {
				this.load();
				this.$buefy.notification.open({
					message: this.$t('success-save') as string,
					type: 'is-success',
				});
				modal.close();
			})
			.catch(({ data }) => {
				this.$buefy.notification.open({
					message: data.msg || data.internal,
					type: 'is-danger',
				});
			});
	}

	addConto() {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditConto,
			props: {
				type: this.tab
			},
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Conto) => {
					this.saveConto(value, modal);
				}
			}
		});
	}

	editConto(item: Conto) {
		this.openConto(item);
	}

	openConto(item: Conto) {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditConto,
			props: {
				conto: item,
				type: this.tab
			},
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Conto) => {
					this.saveConto(value, modal);
				}
			}
		});
	}

	deleteConto(item: Conto) {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-conto-delete') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				this.crudService
					.deleteEntity(Conto, 'conto', item)
					.then(() => {
						this.$buefy.notification.open({
							message: this.$t('success-save') as string,
							type: 'is-success',
						});
						this.load();
					})
					.catch((error) => {
						this.$buefy.notification.open({
							message: error.msg,
							type: 'is-danger',
						});
					});
			}
		});
	}

}
